module.exports = __webpack_public_path__ + "img/caas1-m@2.c62050e3.webp";